var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.667 490.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.333 0C110.059 0 0 110.059 0 245.333s110.059 245.333 245.333 245.333 245.333-110.059 245.333-245.333S380.608 0 245.333 0zm0 469.333c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.333 106.667c-5.888 0-10.667 4.779-10.667 10.667v256c0 5.888 4.779 10.667 10.667 10.667S256 379.221 256 373.333v-256c0-5.888-4.779-10.666-10.667-10.666z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.219 195.115l-85.333-85.333c-4.16-4.16-10.923-4.16-15.083 0l-85.333 85.333c-4.16 4.16-4.16 10.923 0 15.083s10.923 4.16 15.083 0l77.781-77.781 77.781 77.803a10.716 10.716 0 007.552 3.115c2.731 0 5.461-1.045 7.552-3.136 4.16-4.162 4.16-10.924 0-15.084z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.4c0ec383.svg";
export { ForwardRef as ReactComponent };